import { Modal, generateResolver, yup, Notification, STATUS_TYPES, ConfirmationPrompt } from 'dyl-components';
import React, { useContext, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Icon, Popup, Modal as SemanticModal } from 'semantic-ui-react';
import { BulkActionsContext } from "shared/context/BulkActionsProvider";
import { useParams, useSearchParams } from 'react-router-dom';
import campaignsActions from 'actions/campaigns';

const CampaignContactsBulkActionsModal = ({ open, onClose, numberSelectedContacts = 0, readContacts }) => {
    const { id: campaign_id } = useParams();
    const [isPromptOpen, setIsPromptOpen] = useState(false);
    const [query] = useSearchParams();
    const search = query.get("search") || '';
    const module = query.get("module") || '';
    const status = query.get("campaign_converted") || '';
    const { campaigns, isReadingCampaigns } = useSelector(state => ({
        campaigns: state.campaigns.campaigns,
        isReadingCampaigns: state.campaigns.isReadingCampaigns
    }))

    const { control, reset, formState: { isValid, isDirty }, handleSubmit, watch } = useForm({
        mode: 'onChange',
        defaultValues: {
            type: '',
        },
        resolver: generateResolver({
            type: yup.string().required('This field is required'),
        })
    });

    const typeWatch = watch('type');

    const dispatch = useDispatch();

    const close = () => {
        reset();
        onClose();
    }
    
    const [selectedContacts,,areContactsInAllPagesSelected] = useContext(BulkActionsContext);

    const bulkActionOptions = [
        {
            key: 'add_to_campaign', value: 'add_to_campaign', text: 'Add to Campaign', content: (
                <>
                    <Icon className={`fas fa-megaphone`} />
                    Add to Campaign
                </>
            )
        },
        {
            key: 'remove_from_campaign', value: 'remove_from_campaign', text: 'Remove From Campaign', content: (
                <>
                    <Icon className={`fas fa-trash`} />
                    Remove From Campaign
                </>
            )
        },
        {
            key: 'set_to_active', value: 'set_to_active', text: 'Set to Active', disabled: true, content: (
                <>
                    Set to Active
                </>
            )
        },
        {
            key: 'set_to_inactive', value: 'set_to_inactive', text: 'Set to Inactive', disabled: true, content: (
                <>
                    Set to Inactive
                </>
            )
        },
    ];

    const getMessages = (type) => {
        switch (type) {
            case "remove_from_campaign":
                return {
                    successMessage: "Successfully removed from campaign!",
                    errorMessage: "Failed to remove from campaign"
                }
            case "set_to_active":
                return {
                    successMessage: "Successfully added to group!",
                    errorMessage: "Failed to add to group"
                }
            case "set_to_inactive":
                return {
                    successMessage: "Successfully added to campaign!",
                    errorMessage: "Failed to add to campaign"
                }
            case "add_to_campaign":
                 return {
                    successMessage: "Successfully added to campaign!",
                    errorMessage: "Failed to add to campaign"
                }
            default: {}
        }
    }

    const onBulkAction = async ({ type, campaign }) => {
        const { successMessage, errorMessage } = getMessages(type);
        try {
            await dispatch(campaignsActions.campaignContactsBulkAction("", { payload: !areContactsInAllPagesSelected ? selectedContacts : [] }, { action: type, search, module, status, campaign_id, new_campaign_id: campaign }));
            Notification.alert(successMessage, STATUS_TYPES.SUCCESS);
            close();
            setIsPromptOpen(false);
            readContacts();
        } catch (error) {
            console.log(error);
            Notification.alert(errorMessage, STATUS_TYPES.ERROR);
        }
    }

    return (
        <>
            <Modal open={open} onClose={close}>
                <Modal.Header>
                    Bulk Action <div style={{ float: 'right', marginRight: '1em' }}>
                        <small>{numberSelectedContacts} selected</small>
                        <Popup
                            trigger={<Icon size='small' style={{ marginLeft: '1em' }} floated='right' className='fas fa-circle-info' color='primary' />}
                            content={`Duplicates will be ignored`}
                            inverted
                            position='left center'
                            wide
                        />
                    </div>
                </Modal.Header>
                <Modal.Content>
                    <Form noValidate>
                        <Controller
                            name='type'
                            control={control}
                            render={({ field: { name, value, onChange }, fieldState: { error } }) => (
                                <Form.Select
                                    {...value ? { text: bulkActionOptions.find(action => action.value === value)?.content } : {}}
                                    label='Bulk Action Type'
                                    placeholder='Select bulk action type'
                                    onChange={(_, { value }) => { onChange({ target: { name, value } }) }}
                                    value={value}
                                    options={bulkActionOptions}
                                    required
                                    error={error?.message}
                                    width={8}
                                    selectOnBlur={false}
                                />
                            )}
                        />
                        {typeWatch === "add_to_campaign" && (
                            <Controller
                                name='campaign'
                                control={control}
                                render={({ field: { name, value, onChange } }) => (
                                    <Form.Select
                                        value={value}
                                        options={campaigns.filter((campaign) => !campaign.deleted).map((campaign) => ({ key: campaign.id, text: campaign.name, value: campaign.id }))}
                                        onChange={(_, { value }) => {
                                            onChange({ target: { name, value } });
                                        }}
                                        placeholder={
                                            <div>
                                                <Icon
                                                    style={{ marginRight: 10 }}
                                                    name="search"
                                                />
                                                Select an Existing Campaign Name
                                            </div>
                                        }
                                        label='Campaign Name'
                                        loading={isReadingCampaigns}
                                        search
                                        width={15}
                                        selection
                                        required
                                        selectOnBlur={false}
                                    />
                                )}
                            />
                        )}
                    </Form>
                </Modal.Content>
                <Modal.Actions
                    hasSaveButton
                    saveDisabled={!isValid || !isDirty}
                    onSave={() => setIsPromptOpen(true)}
                />
            </Modal>
            <SemanticModal open={isPromptOpen} style={{ padding: 30, width: 350 }}>
                <ConfirmationPrompt 
                    header={<div style={{ paddingTop: '1em' }}>Are you sure?</div>}
                    // subheader={<div>Selected groups will be permanently deleted.</div>}
                    onConfirm={handleSubmit(onBulkAction)}
                    onCancel={() => setIsPromptOpen(false)}
                />
            </SemanticModal>
        </>
    )
}

export default CampaignContactsBulkActionsModal;
